import { useEffect } from "react";
import { Container } from "ui/components";
import Script from "next/script";
import { netEasyCheckoutKey, netsEastCheckoutUrl } from "features/Modules/Checkout/constants";

//Move into global type for later use

declare global {
  interface Window {
    Dibs?: {
      Checkout: new (options: CheckoutOptions) => CheckoutInstance;
    };
  }

  interface CheckoutOptions {
    checkoutKey: string;
    paymentId: string;
    containerId: string;
  }

  interface CheckoutInstance {
    on(
      event: "payment-completed",
      callback: (response: CheckoutResponse) => void
    ): void;
  }

  interface CheckoutResponse {
    paymentId: string;
  }
}

export interface CheckoutProps {
  className?: string;
  novalidPaymentRedirect?: Umbraco.Link;
  paymentCompletedPage?: Umbraco.Link;
}

export const Checkout: React.FC<CheckoutProps> = ({
  novalidPaymentRedirect,
  paymentCompletedPage,
}) => {
  useEffect(() => {
    const initCheckout = () => {
      if (typeof window === "undefined" || !window.Dibs) return;

      const urlParams = new URLSearchParams(window.location.search);
      const paymentId = urlParams.get("paymentId");

      if (paymentId) {
        const checkout = new window.Dibs.Checkout({
          checkoutKey: netEasyCheckoutKey,
          paymentId,
          containerId: "checkout-container-div",
        });

        checkout.on("payment-completed", (response) => {
          window.location.href = `${paymentCompletedPage?.url}?paymentId=${response.paymentId}`;
        });
      } else {
        window.location.href = novalidPaymentRedirect?.url ?? "/";
      }
    };

    if (window.Dibs) {
      initCheckout();
    } else {
      const handleLoad = () => initCheckout();
      window.addEventListener("netsEasyLoaded", handleLoad);
      return () => window.removeEventListener("netsEasyLoaded", handleLoad);
    }
  }, [novalidPaymentRedirect, paymentCompletedPage]);

  return (
    <Container width="Standard">
      <div id="checkout-container-div"></div>

      <Script
        src={netsEastCheckoutUrl}
        strategy="afterInteractive"
        onLoad={() => {
          window.dispatchEvent(new Event("netsEasyLoaded"));
        }}
      />
    </Container>
  );
};
